import { render, staticRenderFns } from "./CategoryDetailPage.vue?vue&type=template&id=a59fea7c&scoped=true&"
import script from "./CategoryDetailPage.vue?vue&type=script&lang=js&"
export * from "./CategoryDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetailPage.vue?vue&type=style&index=0&id=a59fea7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59fea7c",
  null
  
)

export default component.exports